import { Route } from "found";


import AcceptanceReportPage from "./AcceptanceReportPage";
import AcceptanceReportPageQuery from "./AcceptanceReportPageQuery";
import AdoptedSystemDocumentTemplatesQuery from "./AdoptedSystemDocumentTemplatesQuery";
import PublishedTemplatesPage from "./PublishedTemplatesPage";
import TemplateManagementPage from "./TemplateManagementPage";
import TemplateManagementPageQuery from "./TemplateManagementPageQuery";
import TemplateViewPage from "./view_template/ViewTemplatePage";
import TemplateViewPageQuery from "./view_template/ViewTemplateQuery";

import { PageWrapper } from "pstat-anywhere/utils/pageWrappers";
import { HITS_PER_PAGE } from "pstat-anywhere/components/pages/reports";

const getReportParams = location => ({
  sort: location.query.sort,
  first: location.query.rowsPerPage || HITS_PER_PAGE,
  after: location.query.after
});

const routes = (
  <Route path="template">
    <Route
      path="/manage"
      data={{ routeName: "manage_templates" }}
      query={TemplateManagementPageQuery}
      prepareVariables={(params, { location }) => ({
        ...params,
        ...getReportParams(location)
      })}
      render={({ props }) => (
        <PageWrapper
          component={TemplateManagementPage}
          queryName="systemDocumentTemplates"
          titleKey="systemDocumentTemplates.header"
          {...props}
        />
      )}
    />
    <Route
      path="/:pk(\d+)"
      data={{ routeName: "view_template" }}
      query={TemplateViewPageQuery}
      render={({ props }) => <TemplateViewPage {...props} />}
    />
    <Route
      path="/accept"
      data={{ routeName: "accept_templates" }}
      query={AcceptanceReportPageQuery}
      prepareVariables={(params, { location }) => ({
        ...params,
        ...getReportParams(location)
      })}
      render={({ props }) => (
        <PageWrapper
          component={AcceptanceReportPage}
          queryName="blocSystemDocumentTemplatesAcceptance"
          titleKey="systemDocumentTemplates.acceptanceReport.header"
          {...props}
        />
      )}
    />
    <Route
      path="/published"
      data={{ routeName: "published_templates" }}
      query={AdoptedSystemDocumentTemplatesQuery}
      prepareVariables={(params, { location }) => ({
        ...params,
        ...getReportParams(location)
      })}
      render={({ props }) => (
        <PageWrapper
          component={PublishedTemplatesPage}
          queryName="adoptedSystemDocumentTemplates"
          titleKey="systemDocumentTemplates.published.header"
          {...props}
        />
      )}
    />
  </Route>
);

export default routes;
